import styled, { css } from 'styled-components'
import { Box } from '../UI/Box'

export const TaskContainer = styled(Box)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 350px;
  padding: 1rem 0;
  gap: 1rem;
  h3 {
    color: #fff;
    text-align: center;
    font-feature-settings: 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 104.167% */
    margin: 0 auto;
    max-width: 434px;
  }
  span.description {
    color: #fff;
    text-align: center;
    font-feature-settings: 'dlig' on, 'ss01' on;
    font-family: 'Space Grotesk';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 140% */
    letter-spacing: -0.8px;
  }
  @media screen and (max-width: 1000px) {
    h3 {
      font-size: 1.75rem;
      line-height: 2rem;
    }
    span.description {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`

export const Info = styled.span<{
  type?: 'primary' | 'secondary'
  bordered?: boolean
  hasMargin?: boolean
}>`
  ${(props) =>
    props.type === 'primary'
      ? css`
          color: ${({ theme }) => theme.colors.brandPrimary};
        `
      : css`
          color: #3a5250;
        `}
  ${(props) =>
    props.bordered
      ? css`
          border: 1px solid rgba(255, 255, 255, 0.2);
          padding: 10px;
        `
      : css`
          padding: 4px 0;
        `}
  ${(props) =>
    props.hasMargin
      ? css`
          margin: 0 24px;
        `
      : css`
          margin: 0;
        `}
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  text-transform: uppercase;
  @media screen and (max-width: 1000px) {
    font-size: 16px;
  }
`

export const VariableRewardText = styled(Box)`
  text-transform: uppercase;
  font-size: 12px;
  opacity: 0.5;
`
